import { NavbarTypeEnum } from 'constants/navigation';
import { ThemesModeEnum } from 'constants/themeEnum';
import { LanguagesEnum } from 'constants/languages';
import SecretKey from './encode_key';
interface Environment {
  API_BASE_URL: string;
  APP_BASE_URL: string;
  SOCKET_BASE_URL: string;
  STATIC_DATA_BASE_PATH: string;
  APP_NAME: string;
  DEFAULT_THEME: ThemesModeEnum;
  DEFAULT_NAVIGATION_TYPE: NavbarTypeEnum;
  SIDE_MENU_WIDTH: 240 | 260 | 300;
  DEFAULT_LANGUAGE: LanguagesEnum;
  SECRET_KEY: string;
}

const Development: Environment = {
  // API_BASE_URL: 'https://store1.cellock.com',
  API_BASE_URL: 'http://localhost:1337',
  // 'http://localhost:1337', // localhost, 127.0.0.1
  APP_BASE_URL: 'http://localhost:3000', // localhost, 127.0.0.1
  SOCKET_BASE_URL: 'ws://localhost:1337',
  STATIC_DATA_BASE_PATH: '/uploads/',
  APP_NAME: 'Finer',
  DEFAULT_THEME: ThemesModeEnum.Light,
  DEFAULT_NAVIGATION_TYPE: NavbarTypeEnum.MINI_SIDE_MENU,
  SIDE_MENU_WIDTH: 260,
  DEFAULT_LANGUAGE: LanguagesEnum.English,
  SECRET_KEY: SecretKey,
};

const Prodution: Environment = {
  ...Development,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  SOCKET_BASE_URL: process.env.REACT_APP_SOCKET_BASE_URL || '',
};

export default process.env.NODE_ENV === 'production' ? Prodution : Development;
